import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=58644ff5&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=58644ff5&prod&lang=scss&"
import style1 from "./uploader.vue?vue&type=style&index=1&id=58644ff5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58644ff5",
  null
  
)

export default component.exports